import { cx } from "class-variance-authority"
import { DynamicIcon } from "lucide-react/dynamic"
import { type ComponentPropsWithRef, memo } from "react"

export interface LuDynamicIconProps extends Omit<ComponentPropsWithRef<typeof DynamicIcon>, "name"> {
	icon: ComponentPropsWithRef<typeof DynamicIcon>["name"]
}

export const LuDynamicIcon = memo<LuDynamicIconProps>((props) => {
	const { ref, icon, className, size = "1em", ...rest } = props

	return <DynamicIcon ref={ref} className={cx("shrink-0", className)} name={icon} size={size} {...rest} />
})
LuDynamicIcon.displayName = "LuDynamicIcon"
